<template>
  <div class="grid grid-cols-1 px-2 pb-10 lg:grid-cols-2">
    <div v-for="(project, index) in projects" :key="index">
      <ProjectCard :id="'project-link-' + index" v-bind:project-info="project" />
    </div>
  </div>
</template>

<script>
import ProjectCard from "@/views/dashboard/components/ProjectCard";

export default {
  name: "Projects",
  props: ["projects"],
  components: {
    ProjectCard,
  },
};
</script>
